export { StargateClient as InjectiveStargateClient } from './StargateClient';
export { SigningStargateClient as InjectiveSigningStargateClient } from './SigningStargateClient';
//# sourceMappingURL=index.js.map